// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
    margin-left: auto;
    width: 20px;
    height: 20px;
    text-align: center;
    background-color: red;
    border-radius: 10px;
    color: white;
    line-height:20px;
}

.accordion {
    width: -webkit-fill-available;
}

.expansion-panel-header {
    background-color: #efefef;
    font-weight: bold;
}

    .expansion-panel-header:hover {
        background-color: #efefef;
        font-weight: bold;
    }

    .expansion-panel-header:focus {
        background-color: #efefef;
        font-weight: bold;
    }

.eventhandler-wrapper {
    border: 1px solid var(--appbuilder-primary-color);
    border-top-left-radius: var(--appbuilder-border-radius-top-left);
    border-bottom-left-radius: var(--appbuilder-border-radius-bottom-left);
    border-top-right-radius: var(--appbuilder-border-radius-top-right);
    border-bottom-right-radius: var(--appbuilder-border-radius-bottom-right);
    margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/menutabs/events/events.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;IAEI;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;AAEJ;IACI,iDAAiD;IACjD,gEAAgE;IAChE,sEAAsE;IACtE,kEAAkE;IAClE,wEAAwE;IACxE,aAAa;AACjB","sourcesContent":[".badge {\n    margin-left: auto;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    background-color: red;\n    border-radius: 10px;\n    color: white;\n    line-height:20px;\n}\n\n.accordion {\n    width: -webkit-fill-available;\n}\n\n.expansion-panel-header {\n    background-color: #efefef;\n    font-weight: bold;\n}\n\n    .expansion-panel-header:hover {\n        background-color: #efefef;\n        font-weight: bold;\n    }\n\n    .expansion-panel-header:focus {\n        background-color: #efefef;\n        font-weight: bold;\n    }\n\n.eventhandler-wrapper {\n    border: 1px solid var(--appbuilder-primary-color);\n    border-top-left-radius: var(--appbuilder-border-radius-top-left);\n    border-bottom-left-radius: var(--appbuilder-border-radius-bottom-left);\n    border-top-right-radius: var(--appbuilder-border-radius-top-right);\n    border-bottom-right-radius: var(--appbuilder-border-radius-bottom-right);\n    margin: 5px 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
